import { Text } from "@clipboard-health/ui-react";
import { Box, Card, CardContent, Stack, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

interface CbhCustomChatMessageProps {
  message: string;
  children?: ReactNode;
  avatarSxProps?: SxProps<Theme>;
  messageContainerSxProps?: SxProps<Theme>;
}

export function CbhCustomChatMessage(props: CbhCustomChatMessageProps) {
  const { message, children, avatarSxProps, messageContainerSxProps } = props;

  return (
    // oxlint-disable-next-line typescript/no-misused-spread
    <Stack direction="row" spacing={1} marginBottom={2} sx={{ ...messageContainerSxProps }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          // oxlint-disable-next-line typescript/no-misused-spread
          ...avatarSxProps,
          width: { xs: 14, md: 32 },
          height: { xs: 14, md: 32 },
        }}
      >
        <img src="/bunnyVerticalAgnostic.png" alt="" />
      </Box>
      <Stack>
        <Text variant="caption">Clipboard</Text>
        <Card
          sx={{
            backgroundColor: (theme) => theme.palette.grey[300],
            boxShadow: "none",
            width: { xs: "65vw", md: "auto" },
            mt: 1,
          }}
        >
          <CardContent
            sx={{
              padding: 1,
              "&:last-child": {
                paddingBottom: 1,
              },
            }}
          >
            <Text
              sx={{
                fontSize: 14,
                whiteSpace: "pre-wrap",
              }}
            >
              {message}
            </Text>
          </CardContent>
          {children}
        </Card>
      </Stack>
    </Stack>
  );
}
